module.exports = __webpack_public_path__ + "img/iolRight.1e6a9611.svg";